import TextField from "@/components/common/text-field/TextField.vue";
import Textarea from "@/components/common/Textarea.vue";
import SwitchField from "@/components/common/switch-field/SwitchField.vue";
import NumberField from "@/components/common/number-field/NumberField.vue";
import DatePickerField from "@/components/common/date-picker-field/DatePickerField.vue";
import { useVuelidate } from '@vuelidate/core'
import { required, requiredIf, minValue } from '@vuelidate/validators'

const defaultEl = {
    objectId: null,
    tavlClientId: null,
    billClientId: null,
    vehicleNumber: null,
    name: null,
    comment: null,
    isBillingEnabled: false,
    isRedefinePrice: false,
    price: 0,
    cost: 0,
    isFeatureEnabled: false,
    featureName: null,
    featurePrice: 0,
    nextBillDate: null,
    datetimeUtc: null
}

const minValueIf = (min, condition) => function(value) {
    if (!condition.call(this)) return true
    if (value === null || value === undefined || value === '') return false
    return Number(value) >= min
}
export default {
    name: 'ShowObjectInfo',
    components: {
        TextField,
        Textarea,
        SwitchField,
        NumberField,
        DatePickerField
    },

    data () {
        return {
            object: this.BasicHelper.cloneObject(defaultEl),
            loading: false,
            serverErrors: {}
        }
    },

    setup: () => ({ v$: useVuelidate() }),
    validations () {
        return {
            object: {
                name: { required },
                vehicleNumber: { required },
                price: {
                    required: requiredIf(function() {
                        return this.object.isRedefinePrice
                    }),
                    minValue: minValueIf(1, function() {
                        return this.object.isRedefinePrice
                    })
                },
                featureName: {
                    required: requiredIf(function() {
                        return this.object.isFeatureEnabled
                    })
                },
                featurePrice: {
                    required: requiredIf(function() {
                        return this.object.isFeatureEnabled
                    }),
                    minValue: minValueIf(1, function() {
                        return this.object.isFeatureEnabled
                    })
                },
                nextBillDate: { required }
            }
        }
    },

    methods: {
        async show (billObjectId, companyId) {
            this.loading = true;
            this.v$.$reset();
            this.serverErrors = {}
            this.object = this.BasicHelper.cloneObject(defaultEl);
            try {
                if (billObjectId == null) return;
                const { data } = await this.getObject(billObjectId, companyId);
                if (data) {
                    this.object = this.BasicHelper.cloneObject(data.object);
                }
            } finally {
                this.$refs['modal-window'].show();
                this.loading = false;
            }
        },

        async getObject(billObjectId, companyId) {
            return this.ApiRequest.requestAsync(
                `object/info/${billObjectId}/${companyId}`,
                this.ApiRequest.REQUEST_GET,
                {},
                'object-info',
                true
            );
        },

        async submit () {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                return;
            }
            this.loading = true;
            this.serverErrors = {};
            try {
                const res = await this.ApiRequest.requestAsync(
                    'object/update',
                    this.ApiRequest.REQUEST_POST,
                    this.object,
                    'object-update',
                    true
                );

                if (!res.error) {
                    this.$refs['modal-window'].hide();
                    this.$emit('onChangeObject');
                } else if (res.validationErrors) {
                    this.serverErrors = res.validationErrors;
                }
            } finally {
                this.loading = false;
            }
        },

        close () {
            this.$refs['modal-window'].hide();
        }
    }
}